"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Spinner = require("./Spinner.style");
// @ts-ignore

const Spinner = () => /*#__PURE__*/_react.default.createElement(_Spinner.SpinnerAndTextWrapper, {
  "data-testid": "sbfeed-load-more-spinner"
}, /*#__PURE__*/_react.default.createElement(_Spinner.SpinnerIcon, {
  icon: "circle-notch"
}), /*#__PURE__*/_react.default.createElement(_Spinner.LoadingMoreText, null, "Loading feed..."));
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(Spinner);